import React from 'react';
import { BookOpen, GraduationCap, CheckCircle, ArrowRight, Award, Brain, FileText } from 'lucide-react';
import SEO from '../components/SEO';

const NorquestCollege = () => {
  const structuredData = {
    "@context": "https://schema.org",
    "@type": "Course",
    "name": "CIRE Exam Prep - Norquest College",
    "description": "Exclusive CIRE exam preparation package for Norquest College students. Includes Interactive Book, Mock Exams, and Question Bank.",
    "provider": {
      "@type": "EducationalOrganization",
      "name": "Vitta Finance Academy"
    },
    "offers": {
      "@type": "Offer",
      "price": "34.99",
      "priceCurrency": "CAD"
    }
  };

  const includedFeatures = [
    {
      icon: <BookOpen size={28} color="#1e40af" />,
      title: 'CIRE Interactive Book',
      description: 'Complete interactive study guide covering all 9 CIRO elements with engaging content and visual learning'
    },
    {
      icon: <FileText size={28} color="#1e40af" />,
      title: 'CIRE Mock Exams',
      description: 'Full-length practice exams simulating the real CIRE exam experience with detailed answer explanations'
    },
    {
      icon: <Brain size={28} color="#1e40af" />,
      title: 'CIRE Question Bank',
      description: 'Extensive collection of practice questions organized by element for targeted study sessions'
    }
  ];

  return (
    <div style={{ paddingTop: '80px' }}>
      <SEO 
        title="Norquest College - CIRE Exam Prep | Vitta Finance Academy"
        description="Exclusive CIRE exam preparation package for Norquest College students. Access Interactive Book, Mock Exams, and Question Bank for only $34.99 CAD."
        keywords="Norquest College CIRE, CIRE exam prep Norquest, Norquest finance course, CIRE study materials Edmonton"
        structuredData={structuredData}
      />

      {/* Hero Section */}
      <section style={{
        padding: '80px 20px',
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '900px', margin: '0 auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '12px',
            background: 'rgba(255, 255, 255, 0.15)',
            border: '1px solid rgba(255, 255, 255, 0.3)',
            borderRadius: '20px',
            padding: '10px 24px',
            marginBottom: '24px'
          }}>
            <GraduationCap size={20} />
            <span style={{ fontSize: '0.95rem', fontWeight: '600' }}>EXCLUSIVE FOR NORQUEST COLLEGE STUDENTS</span>
          </div>
          
          <h1 style={{
            fontSize: 'clamp(2rem, 5vw, 3.5rem)',
            fontWeight: '900',
            marginBottom: '20px',
            lineHeight: 1.2
          }}>
            CIRE Exam Preparation
          </h1>
          
          <p style={{
            fontSize: '1.25rem',
            opacity: 0.95,
            maxWidth: '700px',
            margin: '0 auto 16px',
            lineHeight: 1.6
          }}>
            Special pricing for Norquest College students
          </p>

          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '8px',
            background: 'rgba(212, 175, 55, 0.2)',
            border: '2px solid #D4AF37',
            borderRadius: '12px',
            padding: '12px 24px',
            marginBottom: '32px'
          }}>
            <Award size={24} color="#D4AF37" />
            <span style={{ fontSize: '1.5rem', fontWeight: '800' }}>CAD $34.99</span>
            <span style={{ fontSize: '0.9rem', opacity: 0.9 }}>one-time payment</span>
          </div>

          <div>
            <a 
              href="https://vittafinance.mykajabi.com/offers/8ppSq53Q"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="norquest-payment-hero-btn"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '10px',
                padding: '18px 40px',
                background: 'linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)',
                color: 'white',
                borderRadius: '12px',
                textDecoration: 'none',
                fontSize: '1.15rem',
                fontWeight: '700',
                boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
                transition: 'transform 0.2s'
              }}
            >
              Get Access Now
              <ArrowRight size={22} />
            </a>
          </div>
        </div>
      </section>

      {/* What's Included */}
      <section style={{ padding: '80px 20px', background: 'white' }}>
        <div style={{ maxWidth: '1000px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '50px' }}>
            <h2 style={{
              fontFamily: 'Georgia, serif',
              fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
              fontWeight: '700',
              color: '#0f172a',
              marginBottom: '16px'
            }}>
              What's Included
            </h2>
            <p style={{
              fontSize: '1.1rem',
              color: '#64748b',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              Everything you need to pass the CIRE exam
            </p>
          </div>

          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '30px'
          }}>
            {includedFeatures.map((feature, idx) => (
              <div key={idx} style={{
                background: '#f8fafc',
                borderRadius: '16px',
                padding: '32px',
                border: '1px solid #e2e8f0',
                textAlign: 'center'
              }}>
                <div style={{
                  width: '70px',
                  height: '70px',
                  background: '#dbeafe',
                  borderRadius: '16px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  margin: '0 auto 20px'
                }}>
                  {feature.icon}
                </div>
                <h3 style={{
                  fontSize: '1.25rem',
                  fontWeight: '700',
                  color: '#0f172a',
                  marginBottom: '12px'
                }}>{feature.title}</h3>
                <p style={{
                  fontSize: '0.95rem',
                  color: '#64748b',
                  lineHeight: 1.6
                }}>{feature.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Payment Section */}
      <section style={{ padding: '80px 20px', background: '#f8fafc' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div style={{
            background: 'white',
            borderRadius: '20px',
            padding: '48px',
            boxShadow: '0 4px 30px rgba(0,0,0,0.08)',
            textAlign: 'center',
            border: '2px solid #1e40af'
          }}>
            <div style={{
              display: 'inline-block',
              background: '#dbeafe',
              color: '#1e40af',
              padding: '8px 20px',
              borderRadius: '20px',
              fontSize: '0.85rem',
              fontWeight: '700',
              marginBottom: '24px'
            }}>
              NORQUEST COLLEGE EXCLUSIVE
            </div>

            <h3 style={{
              fontSize: '1.5rem',
              fontWeight: '700',
              color: '#0f172a',
              marginBottom: '24px'
            }}>
              CIRE Exam Prep Package
            </h3>

            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '12px',
              textAlign: 'left',
              marginBottom: '32px',
              padding: '24px',
              background: '#f8fafc',
              borderRadius: '12px'
            }}>
              {[
                'CIRE Interactive Book - All 9 Elements',
                'CIRE Mock Exams - Full Practice Tests',
                'CIRE Question Bank - 100s of Questions',
                'Lifetime Access',
                'Mobile Friendly'
              ].map((feature, idx) => (
                <div key={idx} style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px'
                }}>
                  <CheckCircle size={20} color="#22c55e" />
                  <span style={{ fontSize: '1rem', color: '#334155' }}>{feature}</span>
                </div>
              ))}
            </div>

            <div style={{
              fontSize: '3.5rem',
              fontWeight: '900',
              color: '#1e40af',
              marginBottom: '8px'
            }}>
              $34.99 <span style={{ fontSize: '1.25rem', fontWeight: '500', color: '#64748b' }}>CAD</span>
            </div>
            <p style={{ fontSize: '0.95rem', color: '#64748b', marginBottom: '28px' }}>
              One-time payment - Lifetime access
            </p>

            <a 
              href="https://vittafinance.mykajabi.com/offers/8ppSq53Q"
              target="_blank"
              rel="noopener noreferrer"
              data-testid="norquest-payment-main-btn"
              style={{
                display: 'inline-flex',
                alignItems: 'center',
                justifyContent: 'center',
                gap: '10px',
                width: '100%',
                padding: '18px 32px',
                background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                color: 'white',
                borderRadius: '12px',
                textDecoration: 'none',
                fontSize: '1.15rem',
                fontWeight: '700',
                boxShadow: '0 4px 15px rgba(30, 64, 175, 0.3)'
              }}
            >
              Pay Now - $34.99 CAD
              <ArrowRight size={22} />
            </a>
          </div>
        </div>
      </section>

      {/* Access Section */}
      <section style={{ padding: '80px 20px', background: 'white' }}>
        <div style={{ maxWidth: '600px', margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: '40px' }}>
            <h2 style={{
              fontFamily: 'Georgia, serif',
              fontSize: 'clamp(1.5rem, 3vw, 2rem)',
              fontWeight: '700',
              color: '#0f172a',
              marginBottom: '16px'
            }}>
              Already Purchased? Access Your Materials
            </h2>
            <p style={{
              fontSize: '1rem',
              color: '#64748b'
            }}>
              Click below to access your study materials
            </p>
          </div>

          <div style={{
            background: '#f8fafc',
            borderRadius: '16px',
            padding: '40px',
            border: '1px solid #e2e8f0'
          }}>
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              gap: '16px'
            }}>
              <a
                href="https://vittafinance.ca/books/cire-interactive"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="norquest-cire-book-link"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: '20px 24px',
                  background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
                  color: 'white',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  fontSize: '1.1rem',
                  fontWeight: '700',
                  boxShadow: '0 4px 15px rgba(30, 64, 175, 0.3)',
                  transition: 'transform 0.2s'
                }}
              >
                <BookOpen size={24} />
                CIRE Interactive Book
                <ArrowRight size={20} />
              </a>
              
              <a
                href="https://vittafinance.ca/books/cire-mock-exam-pack"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="norquest-mock-exam-link"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: '20px 24px',
                  background: 'linear-gradient(135deg, #166534 0%, #22c55e 100%)',
                  color: 'white',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  fontSize: '1.1rem',
                  fontWeight: '700',
                  boxShadow: '0 4px 15px rgba(22, 101, 52, 0.3)',
                  transition: 'transform 0.2s'
                }}
              >
                <FileText size={24} />
                CIRE Mock Exams
                <ArrowRight size={20} />
              </a>
              
              <a
                href="https://vittafinance.ca/books/cire-element-bank"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="norquest-question-bank-link"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: '12px',
                  padding: '20px 24px',
                  background: 'linear-gradient(135deg, #7c3aed 0%, #a78bfa 100%)',
                  color: 'white',
                  borderRadius: '12px',
                  textDecoration: 'none',
                  fontSize: '1.1rem',
                  fontWeight: '700',
                  boxShadow: '0 4px 15px rgba(124, 58, 237, 0.3)',
                  transition: 'transform 0.2s'
                }}
              >
                <Brain size={24} />
                CIRE Question Bank
                <ArrowRight size={20} />
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section style={{
        padding: '80px 20px',
        background: 'linear-gradient(135deg, #1e40af 0%, #3b82f6 100%)',
        color: 'white',
        textAlign: 'center'
      }}>
        <div style={{ maxWidth: '700px', margin: '0 auto' }}>
          <GraduationCap size={50} style={{ marginBottom: '20px', opacity: 0.9 }} />
          <h2 style={{
            fontSize: 'clamp(1.75rem, 3vw, 2.5rem)',
            fontWeight: '700',
            marginBottom: '16px'
          }}>
            Start Your CIRE Exam Prep Today
          </h2>
          <p style={{
            fontSize: '1.1rem',
            opacity: 0.95,
            marginBottom: '32px',
            lineHeight: 1.6
          }}>
            Join your fellow Norquest College students in preparing for the Canadian Investment Regulatory Exam
          </p>
          
          <a 
            href="https://vittafinance.mykajabi.com/offers/8ppSq53Q"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="norquest-payment-cta-btn"
            style={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: '10px',
              padding: '18px 40px',
              background: 'linear-gradient(135deg, #D4AF37 0%, #B8860B 100%)',
              color: 'white',
              borderRadius: '12px',
              textDecoration: 'none',
              fontSize: '1.15rem',
              fontWeight: '700',
              boxShadow: '0 4px 20px rgba(0,0,0,0.2)'
            }}
          >
            Get Access - $34.99 CAD
            <ArrowRight size={22} />
          </a>
        </div>
      </section>
    </div>
  );
};

export default NorquestCollege;
